<section aria-labelledby="tpa_page_heading" class="main-container">
  @if (!isOpenedFromGuest) {
    <h4 id="tpa_page_heading" class="text-w-700 center">
      {{ multilingualService.langMap?.LABEL_FAQS }}
    </h4>
  }

  <div
    role="search"
    class="search-block mr-3"
    [ngClass]="isOpenedFromGuest ? 'search-block-on-light-bg' : 'faq-search'"
  >
    <input
      [(ngModel)]="searchString"
      type="text"
      [attr.aria-label]="multilingualService?.langMap?.LABEL_SEARCH"
      class="form-control faq-search-input"
      placeholder="{{ multilingualService.langMap?.LABEL_FAQ_SEARCH_MESSAGE }}"
      maxlength="40"
      (ngModelChange)="search(searchString)"
      #input
    />
  </div>

  <div [ngClass]="isOpenedFromGuest ? 'guest-tab' : ''" class="membership-list faq-tab-list">
    <mat-tab-group
      [ngClass]="isOpenedFromGuest ? 'mat-custom-tab-on-light-bg' : 'mat-custom-tab'"
      [selectedIndex]="selectedIndex"
      (selectedTabChange)="tabChange($event)"
      animationDuration="0ms"
    >
      <mat-tab
        (selectedTabChange)="onBenefitsFaqClicked()"
        label="{{ multilingualService.langMap?.LABEL_BENEFITS_FAQS }}"
      >
        <div class="mt-2 custom-box">
          @if (isBenefitsFAQsLoading) {
            <div class="center loader-circle">
              <img
                aria-busy="true"
                role="status"
                imageName="loader.gif"
                [common]="true"
                alt="benefit loader"
                width="80px"
              />
            </div>
          }
          @if (!isBenefitsFAQsLoading && isBenefitsFAQsError) {
            <div class="center">
              <img
                aria-hidden="true"
                imageName="something-went-wrong.svg"
                alt="No Data Found"
                width="75px"
              />
              <p class="title-10 text-w-700">{{ errMsg }}</p>
            </div>
          }

          @if (searchString && searchString.length >= 3 && noDataFound) {
            <span class="no-data-found">
              {{ multilingualService.langMap?.LABEL_FAQ_NO_SEARCH_FOUND }}
              <b>{{ searchString }}</b>
            </span>
          }

          @if (benefitsFAQs$ | async; as benefitsFAQs) {
            <mat-accordion [multi]="true" class="faq-accordian">
              @for (faq of benefitsFAQs; track $index) {
                <mat-expansion-panel [expanded]="faq.isExpand">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <p
                        class="expansion-panel-title"
                        [innerHTML]="faq.question | highlight: searchString"
                      ></p>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <p [innerHtml]="faq.answer | highlight: searchString"></p>
                </mat-expansion-panel>
              }
            </mat-accordion>
          }
        </div>
      </mat-tab>
      @if (!(mailOrderService.disableMailOrderFeatures$ | async)) {
        <mat-tab
          (selectedTabChange)="onMailOrderFaqClicked()"
          label="{{ multilingualService.langMap?.LABEL_MAIL_ORDER_FAQS }}"
        >
          <div class="mt-2 custom-box">
            @if (isMailOrdersFAQsLoading) {
              <div class="center loader-circle">
                <img
                  aria-busy="true"
                  role="status"
                  imageName="loader.gif"
                  [common]="true"
                  alt="mail order loader"
                  width="80px"
                />
              </div>
            }
            @if (!isMailOrdersFAQsLoading && isMailOrdersFAQsError) {
              <div class="center">
                <img
                  aria-hidden="true"
                  imageName="something-went-wrong.svg"
                  alt="No Data Found"
                  width="75px"
                />
                <p class="title-10 text-w-700">{{ errMsg }}</p>
              </div>
            }
            @if (searchString && searchString.length >= 3 && noDataFound) {
              <span class="no-data-found">
                {{ multilingualService.langMap?.LABEL_FAQ_NO_SEARCH_FOUND }}
                <b>{{ searchString }}</b>
              </span>
            }
            @if (mailOrdersFAQs$ | async; as mailOrdersFAQs) {
              <mat-accordion [multi]="true" class="faq-accordian">
                @for (faq of mailOrdersFAQs; track $index) {
                  <mat-expansion-panel [expanded]="faq.isExpand">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <p
                          class="expansion-panel-title"
                          [innerHTML]="faq.question | highlight: searchString"
                        ></p>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p [innerHTML]="faq.answer | highlight: searchString"></p>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            }
          </div>
        </mat-tab>
      }
      <mat-tab
        (selectedTabChange)="onClinicalFaqClicked()"
        label="{{ multilingualService.langMap?.LABEL_CLINICAL_REVIEW_FAQS }}"
      >
        <div class="mt-2 custom-box">
          @if (isClinicalFAQsLoading) {
            <div class="center loader-circle">
              <img
                aria-busy="true"
                role="status"
                imageName="loader.gif"
                [common]="true"
                alt="clinical review loader"
                width="80px"
              />
            </div>
          }
          @if (!isClinicalFAQsLoading && isClinicalFAQsError) {
            <div class="center">
              <img
                aria-hidden="true"
                imageName="something-went-wrong.svg"
                alt="No Data Found"
                width="75px"
              />
              <p class="title-10 text-w-700">{{ errMsg }}</p>
            </div>
          }

          @if (searchString && searchString.length >= 3 && noDataFound) {
            <span class="no-data-found">
              {{ multilingualService.langMap?.LABEL_FAQ_NO_SEARCH_FOUND }}
              <b>{{ searchString }}</b>
            </span>
          }

          @if (clinicalFAQs$ | async; as clinicalFAQs) {
            <mat-accordion [multi]="true" class="faq-accordian">
              @for (faq of clinicalFAQs; track $index) {
                <mat-expansion-panel [expanded]="faq.isExpand">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <p
                        class="expansion-panel-title"
                        [innerHTML]="faq.question | highlight: searchString"
                      ></p>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <p [innerHTML]="faq.answer | highlight: searchString"></p>
                </mat-expansion-panel>
              }
            </mat-accordion>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
